import { Component, OnInit } from '@angular/core';
import { FacturacionService } from '../facturacion/facturacion.service';

@Component({
  selector: 'app-promociones',
  templateUrl: './promociones.component.html',
  styleUrls: ['./promociones.component.scss']
})
export class PromocionesComponent implements OnInit {

  public promociones = [];
  public servicioApi;
  public servidor = ["copico","aprosi","comersur"];
  constructor(servicioWeb:FacturacionService) {
    this.servicioApi = servicioWeb;            
   }

  ngOnInit(): void {

    this.obtenerPromociones();
  }

  obtenerPromociones()
  {
    for(let i = 0; i <this.servidor.length; i ++)
    {
      this.servicioApi.obtenerPromociones(this.servidor[i]).subscribe(
        data =>{
          this.promociones.push(...data);                
        }
      );
    }    
  }
}
